var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00013 2.33333H3.13346C2.38673 2.33333 2.01308 2.33333 1.72786 2.47866C1.47698 2.60649 1.27316 2.81032 1.14532 3.0612C1 3.34641 1 3.72006 1 4.4668V10.8668C1 11.6135 1 11.9867 1.14532 12.2719C1.27316 12.5228 1.47698 12.727 1.72786 12.8548C2.0128 13 2.386 13 3.13127 13H9.53539C10.2807 13 10.6533 13 10.9383 12.8548C11.1891 12.727 11.3937 12.5226 11.5215 12.2717C11.6667 11.9868 11.6667 11.614 11.6667 10.8687V9M9 3L5 7V9H7L11 5M9 3L11 1L13 3L11 5M9 3L11 5",
    stroke: "#646A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNotes);
export default __webpack_public_path__ + "static/media/EditNotes.b2f9413ef4f6b7268c7520c394cc315e.svg";
export { ForwardRef as ReactComponent };